import { Popup as MapLibrePopup } from 'maplibre-gl'
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import { hideMapPopup } from '../../../store/map/mapSlice'
import { isPE } from '../../Device'
import { withEmptyFallbackErrorBoundary } from '../../error/EmptyFallbackErrorBoundary'
import { withMapInitialized } from '../map.utils'
import { useMapContext } from '../MapContext'
import s from './Popup.less'
import {
  POPUP_TYPE_ADDRESS,
  POPUP_TYPE_PANO,
  POPUP_TYPE_POI,
  selectPopupData,
  selectShouldDisplayPopup
} from './popup.selectors'
import PopupAddress from './PopupAddress'
import PopupPano from './PopupPano'
import PopupPoi from './PopupPoi'

// webpack:BrowserOnly

const popupDataAreComplete = ({ offset, coords, type }) => type && offset && coords && coords.lat && coords.lng

const getChild = type => {
  switch (type) {
    case POPUP_TYPE_PANO:
      return <PopupPano />
    case POPUP_TYPE_POI:
      return <PopupPoi />
    case POPUP_TYPE_ADDRESS:
      return <PopupAddress />
    default:
      return null // 'null' is important to have a falsy return
  }
}

const POPUP_ID = 'mapPopupWrapper'

const useMapLibrePopup = () => {
  const dispatch = useDispatch()
  const popupData = useSelector(selectPopupData)
  const shouldHavePopup = popupDataAreComplete(popupData)
  const [hasPopup, setHasPopup] = useState(0)
  const { type, coords, offset, anchor, maxWidth, withIllustration } = popupData
  const { map } = useMapContext()

  useEffect(() => {
    if (!shouldHavePopup) return

    const popupTypeClass = ` popup-${type}`
    const withIllustrationClass = withIllustration ? ' with-illustration' : ''

    const mapLibrePopup = new MapLibrePopup({
      offset,
      closeButton: false,
      className: `${s.popup}${popupTypeClass}${withIllustrationClass}`,
      anchor,
      maxWidth
    })

    mapLibrePopup.setLngLat(coords).setHTML(`<div id="${POPUP_ID}"></div>`).addTo(map)

    setHasPopup(Date.now())

    return () => {
      mapLibrePopup.remove()
      setHasPopup(0)
    }
  }, [shouldHavePopup])

  useEffect(() => {
    const clickHandler = () => {
      dispatch(hideMapPopup())
    }
    map.on('click', clickHandler)

    return () => {
      map.off('click', clickHandler)
    }
  }, [hideMapPopup])

  return hasPopup && POPUP_ID
}

const PortalPopup = ({ children }) => {
  const popupId = useMapLibrePopup()

  if (!popupId) return <></>

  const domNode = document.querySelector(`#${popupId}`)
  if (!domNode) return <></>
  return ReactDOM.createPortal(children, domNode)
}

const Popup = () => {
  const { type } = useSelector(selectPopupData)
  const child = getChild(type)
  const shouldDisplayPopup = useSelector(selectShouldDisplayPopup)

  if (!shouldDisplayPopup || !child) return <></>
  if (isPE() && type === POPUP_TYPE_ADDRESS) return <></>

  return isPE() ? <div className={s.popupPE}>{child}</div> : <PortalPopup>{child}</PortalPopup>
}

export default withEmptyFallbackErrorBoundary(withMapInitialized(Popup))
